module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COVER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-preface003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface003"
    }
  }, [_vm._v("AUTHOR NOTE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("CHAPTER 1: POMEGRANATES FULL AND FINE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("CHAPTER 2: IT RUNS IN THE FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: A HOST OF FURIOUS FANCIES")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: DEATH IN THE FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: MY SISTER’S KEEPER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: THE LUNATICS HAVE TAKEN OVER THE ASYLUM")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: STRAYING LATE AND LONELY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8: IN THE COMPANY OF COURTESANS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9: I AM NOT AN ANIMAL")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10: CURIOUSER AND CURIOUSER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11: SURPRISES, LIKE MISFORTUNES, SELDOM COME ALONE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12: ADVERSITY IS THE FIRST PATH TO TRUTH")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13: THE PURE AND SIMPLE TRUTH IS RARELY PURE AND NEVER SIMPLE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14: NOT SINGLE SPIES BUT AS BATTALIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15: I BEHELD THE WRETCH – THE MISERABLE MONSTER WHOM I HAD CREATED")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16: MORALITY, LIKE ART, MEANS DRAWING A LINE SOME PLACE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17: TO THE DEAD WE OWE ONLY THE TRUTH")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18: TRUTH IS THE BEGINNING OF EVERY GOOD THING")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNDERSTANDING THE ARISTOCRACY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-acknowledgements"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXTRAS")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-personblurb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/personblurb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEET THE AUTHOR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-teaser001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("THE QUEEN IS DEAD")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "toc-teaser002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("STRANGE PRACTICE")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-ad-card"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard"
    }
  }, [_vm._v("BY KATE LOCKE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-glossary"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Newsletters"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterOrbit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORBIT NEWSLETTER")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter001"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0